import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './home/home';
import { Portfolio } from './portfolio/portfolio';
import { Projects } from './projects/Project'
import { Resume } from './resume/Resume'
import { Blog } from './blog/blog'
import NotFound from './notfound/NotFound'
import { Photos } from './photos/Photos'
import Footer from './containers/footer/footer';
import Navbar from './navbar/navbar';

const RouteWrapper = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/photos" element={<Photos />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <>
      <Router>
        <Navbar />
        <RouteWrapper />
      </Router>
      {<Footer />}
    </>
  );
};

export default App;